const t = {
  APP: {
    name: "App",
    description: "Application infrastructure endpoints (health, status)"
  },
  AUTH: {
    name: "Auth",
    description: "Authentication endpoints"
  },
  CAMPAIGNS: {
    name: "Campaigns",
    description: "Campaign management endpoints"
  },
  TARGET_GROUPS: {
    name: "Target Groups",
    description: "Target group management endpoints"
  },
  CREATIVE_GROUPS: {
    name: "Creative Groups",
    description: "Creative group and asset management endpoints"
  },
  ASSETS: {
    name: "Assets",
    description: "Asset management endpoints"
  },
  AD_GROUPS: {
    name: "Ad Groups",
    description: "Ad group and pricing rule management endpoints"
  },
  DOMAINS: {
    name: "Domains",
    description: "Domain listing endpoints"
  },
  AD_UNITS: {
    name: "Ad Units",
    description: "Ad unit listing endpoints"
  },
  DICTIONARY: {
    name: "Dictionary",
    description: "Dictionary data endpoints (countries, regions)"
  },
  ARBITRAGE_MODEL_RULES: {
    name: "Arbitrage Model Rules",
    description: "Arbitrage model rule listing endpoints"
  },
  BLACKLIST_AUTO_RULES: {
    name: "Blacklist Auto Rules",
    description: "Blacklist auto-rule management endpoints"
  },
  GOALS: {
    name: "Goals",
    description: "Postback (goal) management endpoints"
  },
  ROTATOR_CAMPAIGNS: {
    name: "Rotator Campaigns",
    description: "Rotator settings of a pricing rule"
  },
  ACCOUNT: {
    name: "Account",
    description: "Read-only data about the calling user account"
  },
  STATISTICS: {
    name: "Statistics",
    description: "Statistics proxy endpoints (ae-stat)"
  }
}, i = Object.values(t), a = (...n) => n.map((e) => e.name);
export {
  t as SwaggerTags,
  a as getTagNames,
  i as swaggerTags
};
//# sourceMappingURL=tags.js.map
